function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M401.9,217.9c0.8,6.7,6.9,11.5,13.7,10.6c6.7-0.8,11.5-7,10.6-13.7c-12-95.7-103.3-167.9-212.5-167.9 C95.9,46.9,0,131.7,0,235.8c0,40.9,15.1,80.8,42.8,113.4c-5.7,12.1-13.9,21.7-24.4,28.5c-6.3,4.1-9.3,11.6-7.7,18.9 c1.6,7.2,7.5,12.6,14.8,13.6c16.7,2.3,48.3,3.6,78.7-12.1c33.1,17.4,70.7,26.6,109.4,26.6c22.4,0,44.4-3,65.5-9 c6.5-1.9,10.3-8.6,8.4-15.1c-1.8-6.5-8.6-10.3-15.1-8.4c-18.9,5.4-38.7,8.1-58.8,8.1c-36.8,0-72.6-9.3-103.4-26.8 c-3.8-2.2-8.6-2.1-12.4,0.1c-17.9,10.7-37,13.5-52,13.5c-0.1,0-0.2,0-0.2,0c9.9-9.7,17.6-21.8,22.8-36c1.6-4.3,0.6-9.2-2.5-12.6 c-27.2-29.5-41.5-65-41.5-102.7c0-90.7,84.9-164.4,189.3-164.4C310.6,71.4,391.4,134.4,401.9,217.9z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 213.6,
  cy: 235.8,
  r: 13.6
}), /*#__PURE__*/React.createElement("circle", {
  cx: 155.1,
  cy: 235.8,
  r: 13.6
}), /*#__PURE__*/React.createElement("circle", {
  cx: 272.2,
  cy: 235.8,
  r: 13.6
}), /*#__PURE__*/React.createElement("path", {
  d: "M388.3,239.8c-56,0-101.5,45.5-101.5,101.5s45.5,101.6,101.5,101.6s101.5-45.5,101.5-101.5S444.3,239.8,388.3,239.8z  M388.3,418.4c-42.5,0-77-34.6-77-77s34.6-77,77-77s77,34.6,77,77S430.8,418.4,388.3,418.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M419.7,329.1h-19.2v-19.2c0-6.8-5.5-12.3-12.3-12.3s-12.3,5.5-12.3,12.3v19.2h-19c-6.8,0-12.3,5.5-12.3,12.3 s5.5,12.3,12.3,12.3h19.2v19.2c0,6.8,5.5,12.3,12.3,12.3s12.3-5.5,12.3-12.3v-19.2h19.2c6.8,0,12.3-5.5,12.3-12.3 S426.5,329.1,419.7,329.1z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var SvgChatStart = function SvgChatStart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 489.8 489.8",
    style: {
      enableBackground: "new 0 0 489.8 489.8"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChatStart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chat-start.cbb2af31.svg";
export { ForwardRef as ReactComponent };